import { useRef } from "react";

/**
 * useTypingPing — throttled keystroke ping (one POST every 3s while typing).
 * Call ping() from the textarea onChange handler.
 */
export default function useTypingPing(send, throttleMs = 3000) {
  const lastSentRef = useRef(0);

  return function ping() {
    const now = Date.now();
    if (now - lastSentRef.current < throttleMs) return;
    lastSentRef.current = now;
    send().catch(() => {
      // typing pings are fire-and-forget
    });
  };
}
